<div class="cont-title-sec">
  <h1 class="title-sect color-blue-dark font-30 f-31 wr-100 m-0">
    <ng-content></ng-content>
  </h1>
</div>
